/**
 * Request source cancel token container
 */
const RequestSource = {
  cancel_tokens: {},

  createCancelToken: function (request_client, token_key) {
    this.cancel_tokens[token_key] = request_client.createCancelToken();
    return this.getCancelToken(token_key);
  },

  getCancelToken: function(token_key) {
    return this.cancel_tokens[token_key] || null;
  },

  cancelToken: function (token_key) {
    var source = this.getCancelToken(token_key);
    if (source) source.cancel();
  },

  renewCancelToken: function (reques_client, token_key) {
    if (this.getCancelToken(token_key) !== null) {
        this.cancelToken(token_key);
        delete this.cancel_tokens[token_key];
    }
    return this.createCancelToken(reques_client, token_key);
  }
};

export default RequestSource;